import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocCheckboxes } from '../model/docChecboxes';
import { DocumentModel } from '../model/DocumentModel';
import { ImpressionEtiquetteData } from '../model/ImpressionEtiquetteData';
import { ListeDocumentsService } from './liste-documents/liste-documents.service';

@Component({
  selector: 'app-impression-etiquette-template',
  templateUrl: './impression-etiquette-template.component.html',
  styleUrls: ['./impression-etiquette-template.component.css']
})
export class ImpressionEtiquetteTemplateComponent implements OnInit {
  color = "primary";
  listeDocuments: DocumentModel[];
  listeDocCheckboxes: DocCheckboxes[];

  constructor(
    public dialogRef: MatDialogRef<ImpressionEtiquetteTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImpressionEtiquetteData,
    public listeDocService: ListeDocumentsService
  ){}

  ngOnInit(){
    // Variables MOCK
    var idMouvement = " M19033955";
    var noLigne = 232130;
    var loginUser = "";

    this.listeDocService.recupListeDocuments(idMouvement, noLigne, loginUser).subscribe(result => {
        this.listeDocuments = JSON.parse(JSON.stringify(result));
        console.log("liste: ", this.listeDocuments);
      },
    (error) => {
        console.log("Erreur: ", error);
    })
  }

  count(i: number){
    return new Array(i);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectAll(event: boolean){
    this.listeDocuments.forEach(document => {
      document.b_docuser = event;
    })
  }
}
